import React from 'react';
import * as S from "./style";
import { Link } from 'react-router-dom';
import Routes from '../../../../routes/routes';
import ParentAreaAnimationMobile from '../../../../common/animation/animation-components/ParentAreaAnimationMobile';
import ParentAreaAnimationDesktop from '../../../../common/animation/animation-components/ParentAreaAnimationDesktop';
import ParentImage from "~images/sem/parent_img.svg";
import Image from '../../../../../../app/js/components/loggedout/common/Image';
import { CTAOfferButton } from '../../../../common/styled-components/styled-components';
import MediaQuery from "react-responsive";
import { breakpoints } from '../../../../../../app/js/utils/responsive_utilities';
import LazyLoad from 'react-lazyload';
import { deepCoveDark } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import LayeredBackground from "~images/sem/layer.svg";

const ParentArea = ({trackPromoPageEvents, settings}) => {
  let ctaText = settings.trial_days ? `Try for free` : 'Subscribe Now';
  return (
    <S.ContainerWrapper>
      <S.HeadingText>Track your child’s progress in the parent area</S.HeadingText>
      <S.SubHeadingText>Become your child’s learning partner with trackable reports and watch them progress daily</S.SubHeadingText>
      <S.AnimationWrapper>
        <LazyLoad once offset={50}>
          <MediaQuery query={`(min-width: ${breakpoints.md}px)`}>
            <ParentAreaAnimationDesktop />
          </MediaQuery>
          <MediaQuery query={`(max-width: ${breakpoints.md}px)`}>
            <ParentAreaAnimationMobile />
          </MediaQuery>
        </LazyLoad>
      </S.AnimationWrapper>

      <S.ParentReviewSection>
        <S.ImageWrapper>
          <Image src={ParentImage} />
        </S.ImageWrapper>
        <S.Review>Its quite detailed. Can see what my child has learnt and skills mastered</S.Review>
      </S.ParentReviewSection>
      <S.ButtonWrapper>
        <CTAOfferButton white={true} textColor={deepCoveDark} fontWeight="600" hoverColor="rgb(237, 237, 249)">
          <Link to={Routes.PURCHASE_ROUTE} onClick={()=>trackPromoPageEvents("Promo Page Interacted", {'clicked_on' : 'CTA8'}, true)}>
            {ctaText}
          </Link>
        </CTAOfferButton>
      </S.ButtonWrapper>
      <S.BackgroundWrapper>
        <Image src = {LayeredBackground} />
      </S.BackgroundWrapper>
    </S.ContainerWrapper>
  )
}

export default ParentArea;